import { ShortDataModel } from 'Models'
import {
	BenefInfoType,
	PurchaseType,
	GuaranteeMediumType,
	ProductType,
	BankGuaranteeTypes,
	GuaranteeType,
} from 'Pages/ibro'

export class BgDict {
	public arbitrages: string[] = []
	public facts: ShortDataModel[] = []
	public statuses: ShortDataModel[] = []
	public purchasetypes: ShortDataModel<PurchaseType>[] = []
	public guaranteetypes: ShortDataModel<GuaranteeType>[] = []
	public guaranteemediumtypes: ShortDataModel<GuaranteeMediumType>[] = []
	public producttypes: ShortDataModel<ProductType>[] = []
	public segments: ShortDataModel[] = []
	public front_statuses: ShortDataModel[] = []
	public taxationsystems: ShortDataModel[] = []
	public benefs: ShortDataModel<BenefInfoType>[] = []
	public reputations: ShortDataModel[] = []
	public typelegalauthorities: ShortDataModel[] = []
	public taxreasons: ShortDataModel[] = []
	public ptypes: ShortDataModel<BankGuaranteeTypes>[] = []
	public allowed_symbols = ''
	public publication_subjects: ShortDataModel[] = []
}
